export default __webpack_public_path__ + "static/media/backhoe_1.d84518ba.png";